import http from "../../http-common";
/**
 * Author : AndréK
 * 26/08/2022
*/

//StockLocation
const createStockLocation = (data) => {
    return http.post("/StockLocation/InsertStockLocation", data);
};

const getStockLocation = (data) => {
    return http.post("/StockLocation/FilterStockLocation", data);
};

const updateStockLocation = (data) => {
    return http.post("/StockLocation/UpdateStockLocation", data);
};

//Storage
const createStockLocationStorage = (data) => {
    return http.post("/StockLocation/InsertStockLocationStorage", data);
};

const getStockLocationStorage = (data) => {
    return http.post("/StockLocation/FilterStockLocationStorage", data);
};

const updateStockLocationStorage = (data) => {
    return http.post("/StockLocation/UpdateStockLocationStorage", data);
};

//Street
const createStockLocationStreet = (data) => {
    return http.post("/StockLocation/InsertStockLocationStreet", data);
};

const getStockLocationStreet = (data) => {
    return http.post("/StockLocation/FilterStockLocationStreet", data);
};

const updateStockLocationStreet = (data) => {
    return http.post("/StockLocation/UpdateStockLocationStreet", data);
};

//Column
const createStockLocationColumn = (data) => {
    return http.post("/StockLocation/InsertStockLocationColumn", data);
};

const getStockLocationColumn = (data) => {
    return http.post("/StockLocation/FilterStockLocationColumn", data);
};

const updateStockLocationColumn = (data) => {
    return http.post("/StockLocation/UpdateStockLocationColumn", data);
};

//Level
const createStockLocationLevel = (data) => {
    return http.post("/StockLocation/InsertStockLocationLevel", data);
};

const getStockLocationLevel = (data) => {
    return http.post("/StockLocation/FilterStockLocationLevel", data);
};

const updateStockLocationLevel = (data) => {
    return http.post("/StockLocation/UpdateStockLocationLevel", data);
};


export default {
    createStockLocation,
    getStockLocation,
    updateStockLocation,
    createStockLocationStorage,
    getStockLocationStorage,
    updateStockLocationStorage,
    createStockLocationStreet,
    getStockLocationStreet,
    updateStockLocationStreet,
    createStockLocationColumn,
    getStockLocationColumn,
    updateStockLocationColumn,
    createStockLocationLevel,
    getStockLocationLevel,
    updateStockLocationLevel
};
